import React from "react";
import { Container, Navbar, Row, Col, CloseButton } from "react-bootstrap";
import { useHistory } from "react-router";
import "./Help.css";
import "../DrillDownPage.css";
import { useSelector } from "react-redux";

const HelpHeader = () => {
  const history = useHistory();
  const helpData = useSelector((state) => state?.dashboard?.help);
  const interval = useSelector((state) => state?.globalFilters?.interval);

  return (
    <Navbar className="header-medication drilldown-header">
      <Container fluid className="px-0">
        <Row className="drilldown-header-row w-100 align-items-center">
          <Col xs={12} sm={7} md={7} lg={8}>
            <div className="drilldown-header-brand">
              <div className="drilldown-header-brand-icon">
                <img src="/images/dashboard/help_icon.png" alt="Call For Help" />
              </div>
              <div className="drilldown-header-title-block">
                <span className="header-text">Call For Help</span>
              </div>
              <div className="drilldown-header-count">
                <span className="event-count">{helpData?.counts?.total}</span>
              </div>
            </div>
          </Col>
          <Col xs={12} sm={5} md={5} lg={4}>
            <div className="drilldown-header-actions">
              <h5 className="event-days">{interval}</h5>
              <CloseButton
                style={{ opacity: "1" }}
                variant="white"
                aria-label="Hide"
                onClick={() => history.goBack()}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </Navbar>
  );
};

export default HelpHeader;
